import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import * as $ from 'jquery';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { QueryParameters } from '../../../analytics-core/interfaces/query-parameters.interface';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

import { DaterangepickerComponent, DaterangepickerDirective } from '../daterangepicker';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-ngx-date-range-picker',
	styleUrls: ['./ngx-date-range-picker.component.css'],
	templateUrl: './ngx-date-range-picker.component.html'
})
export class NgxDateRangePickerComponent implements OnInit {
	public firstChange = true;
	public daterange: any = {
		end: moment(),
		label: '',
		start: moment().subtract(1, 'months')
	};
	public isR10: boolean;
	public isR9: boolean = false;
	picker: DaterangepickerComponent;
	public isActive: boolean = false;
	maxDate: moment.Moment;
	minDate: moment.Moment;
	tooltipText: string;

	selected: { startDate: moment.Moment; endDate: moment.Moment };
	@ViewChild(DaterangepickerDirective, { static: true }) pickerDirective: DaterangepickerDirective;
	inlineDate: any;

	constructor(
		protected activatedRoute: ActivatedRoute,
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService
	) {
		this.maxDate = moment().endOf('month').subtract('1', 'days');
		this.minDate = moment().subtract(2, 'years').subtract(3, 'months').startOf('day');
		// Initialize memoized tooltip text to prevent flickering
		this.tooltipText = this.getTooltipText();
		this.selected = {
			endDate: moment(moment().toISOString()),
			startDate: moment(moment().subtract(1, 'months').toISOString())
		};
		const queryParamsObject: QueryParameters = this.analyticsDataModel.getQueryParamsObj();
		this.selected = this.analyticsService.processQueryParamsDateRanges(queryParamsObject);
		this.applyDate(this.selected);
	}

	isInvalidDate(date: any): any {
		return date > moment().endOf('day') || date < this.minDate;
	}

	ngOnInit(): any {
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
		if (!UtilityService.isUndefinedOrNull(this.pickerDirective)) {
			this.picker = this.pickerDirective.picker;
		}
	}

	public applyDate(e: any): void {
		if (!this.firstChange) {
			this.daterange.start = e.startDate ? e.startDate : this.selected.startDate;
			this.daterange.end = e.endDate ? e.endDate : this.selected.endDate;
			EmitterService.get(EVENT_EMITTERS.DATE_RANGE).emit({
				endDate: this.daterange.end,
				startDate: this.daterange.start
			});
			setTimeout(() => {
				EmitterService.get(EVENT_EMITTERS.REFRESH_DATA).emit(true);
			}, 500);
		}
		$('#errorMessage').css('display', 'none');
		if (e.enableErrorMsg) {
			$('#errorMessage').html(e.errorMsg);
			$('#errorMessage').css('display', 'block');
			$('#wrapper').css('border', '1px solid #db2121');
		}

		this.firstChange = false;
	}
	public showCalendar(event: any): void {
		this.analyticsDataModel.userInteracted = true;
		this.isActive = true;
	}
	public hideCalendar(event: any): void {
		this.isActive = false;
	}

	toggleCalendar(e: any): void {
		if (this.picker.isShown) {
			this.picker.hide();
			this.isActive = this.picker.isShown;
		} else {
			this.pickerDirective.open(e);
			this.isActive = this.picker.isShown;
		}
	}
	getTooltipText(): string {
		const formattedMinDate = this.minDate.format('MMM DD, YYYY');
		return `Data older than 2 years and 1 quarter is archived monthly. Earliest available date: ${formattedMinDate}.`;
	}
}
